import Cta from "./Lot/Cta";
import Images from "./Lot/Images";
import Info from "./Lot/Info";
import useLot from "./Lot/useLot";

type Props = {
  customer_token: string;
  recaptcha_key: string;
  locale: Locale;
  lot: Lot.Lot;
  routes: Lot.Routes;
  strings: Lot.Localizations;
};

export default function Lot(props: Props) {
  const { strings } = props;

  const lot = useLot(props.lot, props.routes.backend, props.customer_token);

  return (
    <div className="lot">
      <Images
        images={lot.images}
        strings={strings}
        title={lot.title}
        artist_name={lot.artist_name}
        artist_lifespan={lot.artist_lifespan}
        object_type={lot.object_type}
        year={lot.year}
      />

      <div className="content">
        <Info lot={lot} strings={strings} />
        <Cta
          loggedIn={props.customer_token ? true : false}
          lot={lot}
          customer_token={props.customer_token}
          recaptcha_key={props.recaptcha_key}
          locale={props.locale}
          routes={props.routes}
          strings={strings}
        />
      </div>

      {(lot.video_embed || lot.body) && (
        <div className="more">
          {lot.video_embed && (
            <div
              className="video-embed"
              dangerouslySetInnerHTML={{ __html: lot.video_embed }}
            />
          )}
          {lot.body && (
            <div
              className="body"
              dangerouslySetInnerHTML={{ __html: lot.body }}
            />
          )}
        </div>
      )}
    </div>
  );
}
